
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {

    display: block
}

.bg-container {

    width: 100%;

    padding-top: 3rem;

    padding-bottom: 3rem;

    padding-left: 2rem;

    padding-right: 2rem
}

@media (min-width: 768px) {

    .bg-container {

        padding-left: 3rem;

        padding-right: 3rem
    }
}

.stat {

    margin-bottom: 0.5rem;

    font-family: Open Sans, Helvetica, Arial, sans-serif;

    font-size: var(--fs-xl);

    line-height: var(--lh-xl);

    font-weight: var(--fw-bold)
}

@media (min-width: 768px) {

    .stat {

        margin-bottom: 1rem
    }

    .stat {

        font-size: var(--fs-4xl);

        line-height: var(--lh-4xl)
    }
}

.stat-container {

    text-align: center
}

.stat-desc {

    margin-top: 0px;

    font-size: var(--fs-base);

    line-height: var(--lh-base)
}

idb-heading {

    margin-bottom: 1.5rem;

    text-align: center
}

.idb-stat-bar-color--blue-white {

    background-color: var(--blue-responsible-main);

    color: var(--neutral-white)
}

.idb-stat-bar-color--gray-blue {

    background-color: var(--gray-professional-lighten-4);

    color: var(--blue-responsible-main)
}

.idb-stat-bar-color--white-blue {

    background-color: var(--neutral-white);

    color: var(--blue-responsible-main)
}

.idb-stat-bar-color--light-blue-blue {

    background-color: var(--blue-responsible-lighten-5);

    color: var(--blue-responsible-main)
}

.idb-stat-bar-color--white-black {

    background-color: var(--neutral-black);

    color: var(--neutral-white)
}
`;